import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import ProductVehicleAssignDialog from "product/component/productVehicleAssignDialog";
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, SECURABLE, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import Grid from "core/grid/domain/grid";
import {BULKACTIONTYPE} from "core/grid/component/gridComp";
import TaskDialog from "core/event/component/taskDialog";
import {ACTIVITYLOCATION, TASKTYPE} from "core/event/eventDomain";
import {action} from "mobx";
import {loc} from "core/common/config/locales";

const gridLocation = 'vehicleList';

@observer
export default class VehicleList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.product;
  static title = loc.i18n`Vehicles`;
  static icon = 'truck';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("VehicleList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }

  private _productVehicleAssignDialog: ProductVehicleAssignDialog;
  private taskDialogRef: TaskDialog;

  assignProducts = (grid: Grid) => {

    new Promise((resolve, reject) => {
      this._productVehicleAssignDialog.open(resolve, reject, grid);
    }).catch( (e) => {})
  };


  @action createTasks = (grid: Grid) => {
    console.log('createTasks');
    return new Promise((resolve, reject) => {
      return this.taskDialogRef.open(resolve, reject, grid.createFullParams());
    }).catch( (e) => {});
  };


  productVehicleAssignDialogRef = comp => {this._productVehicleAssignDialog = comp;};
  taskDialogRefHandler = comp => this.taskDialogRef = comp;

  render() {
    let {params, query} = this.props;

    let bulkActions = [
      {type: BULKACTIONTYPE.ACTION as BULKACTIONTYPE, label: 'Assign Product', fn: this.assignProducts, that:this, securable: SECURABLE.assignProducts},
      {type: BULKACTIONTYPE.ACTION as BULKACTIONTYPE, label: 'Create Tasks', fn: this.createTasks, that:this, securable: SECURABLE.vehiclesNotification}
    ];

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}
                           bulkActions={bulkActions} multiUpdateSecurable={SECURABLE.productGridUpdate}>
          <ZzFlatButtonRoute onGridToolbar routeName="vehicleDetail" params={{id: 'new'}} query={{vehicleType:1}} label={loc.i18n`New Vehicle`} permission={PERMISSION.New} securable={PAGE.vehicleDetail}/>

          <ProductVehicleAssignDialog ref={this.productVehicleAssignDialogRef} />
          <TaskDialog ref={this.taskDialogRefHandler} entities={mdEntityService.entityMap} location={ACTIVITYLOCATION.Vehicle} taskType={TASKTYPE.VEHICLE_NOTIFICATION}/>
        </GridCompConnected>
    );
  }

}




// WEBPACK FOOTER //
// ./src/product/page/vehicleList.tsx